import type { QueryResult } from '@flowqa/shared';

const DEFAULT_PAGE_SIZE = 100;

type FetchPageArgs = {
  page: number;
  pageSize: number;
};

export const fetchAllQueryPages = async <TItem>(
  fetchPage: (args: FetchPageArgs) => Promise<QueryResult<TItem>>,
): Promise<QueryResult<TItem>> => {
  const firstPage = await fetchPage({ page: 1, pageSize: DEFAULT_PAGE_SIZE });
  if (firstPage.total <= firstPage.items.length) {
    return firstPage;
  }

  const allItems = [...firstPage.items];
  let page = 2;

  while (allItems.length < firstPage.total) {
    const nextPage = await fetchPage({ page, pageSize: DEFAULT_PAGE_SIZE });
    allItems.push(...nextPage.items);
    if (nextPage.items.length === 0) {
      break;
    }
    page += 1;
  }

  return {
    ...firstPage,
    items: allItems,
    page: 1,
    pageSize: allItems.length,
  };
};
